import React from 'react';
import { motion } from 'framer-motion';
import TestimonialCard from '../components/TestimonialCard';
import { Link } from 'react-router-dom';
const Home = () => {
  return <div className="bg-white min-h-screen" data-id="element-253">
      {/* Hero Section */}
      <section className="container mx-auto px-4 py-20 flex flex-col md:flex-row items-center justify-between" data-id="element-254">
        <motion.div className="md:w-1/2 flex flex-col items-center md:items-start" initial={{
        opacity: 0.5
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-255">
          <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center md:text-left text-gray-800 mb-4" initial={{
          opacity: 0.5
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5
        }} data-id="element-256">
            Aakash Gupta — VP of Product | SaaS & PLG Leader
          </motion.h1>
          <motion.p className="text-xl text-center md:text-left text-gray-700 mb-8" initial={{
          opacity: 0.5
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-257">
            16+ years scaling products from early-stage apps to
            multi-billion-dollar platforms.
          </motion.p>
        </motion.div>
        <motion.div className="md:w-1/2 flex justify-center mt-8 md:mt-0" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-258">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fh4PvSXUQS6aUgE3nDidGB/AaKsyVTU_%281%29.png" alt="Aakash Gupta" className="rounded-full w-64 h-64 object-cover shadow-lg border-4 border-white" data-id="element-259" />
        </motion.div>
      </section>
      {/* Testimonial Cards Section */}
      <section id="testimonials" className="bg-gray-50 py-16" data-id="element-260">
        <div className="container mx-auto px-4" data-id="element-261">
          <motion.h2 className="text-3xl font-bold text-center text-gray-800 mb-12" initial={{
          opacity: 0.5
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-262">
            Career Highlights
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-263">
            <TestimonialCard company="Apollo.io" position="VP of Product" years="2023 — Present" testimonial="Aakash was a transformational VP of Product, helping us reach $2.5B valuation by driving >100% YoY PLG growth." author="Shek Viswanathan" title="CPO" logo="https://logo.clearbit.com/apollo.io" link="/portfolio/apollo" data-id="element-264" />
            <TestimonialCard company="Affirm" position="Head of Growth Product" years="2021 — 2023" testimonial="Exceptional growth leader… customer-centric, unwavering focus on results." author="Kenneth Wong" title="Director of Engineering" logo="https://logo.clearbit.com/affirm.com" link="/portfolio/affirm" data-id="element-265" />
            <TestimonialCard company="Epic Games" position="Lead PM" years="2019 — 2021" testimonial="Aakash was a huge driver of the success of Fortnite Chapter 2, couldn't have done it without him." author="Jason West" title="Fortnite Director" logo="https://logo.clearbit.com/epicgames.com" link="/portfolio/epic-games" data-id="element-266" />
            <TestimonialCard company="ThredUp" position="Director of Growth" years="2014 — 2017" testimonial="Aakash was the driving force behind our 10x customer acquisition, fueling our $81M Series D+E." author="James Reinhart" title="CEO" logo="https://logo.clearbit.com/thredup.com" link="/portfolio/thredup" data-id="element-267" />
            <TestimonialCard company="Rap to Beats" position="Co-Founder & Product Lead" years="2011 — 2014" testimonial="Aakash scaled our app to 300K MAU, pioneering social music creation on iOS." author="James Dean" title="Founding Engineer" logo="https://uploadthingy.s3.us-west-1.amazonaws.com/rdfB7fVVxZg9cnFNHjimw6/1630501186342.jpg" link="/portfolio/rap-to-beats" data-id="element-268" />
            <TestimonialCard company="ScoutForce" position="Product Manager" years="2008 — 2011" testimonial="As one of our first PMs, Aakash helped us capture 40% of Division I recruiting programs." author="Steve Iacco" title="CEO" logo="https://uploadthingy.s3.us-west-1.amazonaws.com/rGvLnwozxZsFyj5GqYcwtn/1631323871027.jpg" link="/portfolio/scoutforce" data-id="element-269" />
          </div>
          <div className="mt-12 flex justify-center" data-id="element-270">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-271">
              <Link to="/my-story" data-id="element-272">
                <motion.button className="px-8 py-4 bg-[#0FB9B1] text-white rounded-md font-medium text-lg hover:bg-[#0ca69e] transition-colors" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.97
              }} data-id="element-273">
                  Read My Story
                </motion.button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Newsletter/Podcast Highlight */}
      <section className="container mx-auto px-4 py-20" data-id="element-274">
        <motion.h2 className="text-3xl font-bold text-center text-gray-800 mb-12" initial={{
        opacity: 0.5
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-275">
          Newsletter & Podcast
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-276">
          <motion.div className="bg-white rounded-lg shadow-lg overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-277">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/39eQ54FkV2wGnrJ5tWYGkL/newsletterpic.png" alt="Product Growth Newsletter" className="w-full h-48 object-cover" data-id="element-278" />
            <div className="p-6" data-id="element-279">
              <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-280">
                Product Growth Newsletter
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-281">
                The newsletter shaping the next generation of Product Managers.
                Weekly insights, frameworks, and case studies.
              </p>
              <motion.a href="https://www.news.aakashg.com/" className="px-6 py-3 bg-[#0FB9B1] text-white rounded-md font-medium hover:bg-[#0ca69e] transition-colors inline-block" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} target="_blank" rel="noopener noreferrer" data-id="element-282">
                Subscribe
              </motion.a>
            </div>
          </motion.div>
          <motion.div className="bg-white rounded-lg shadow-lg overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-283">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/piRXBQwURyq9Syszkgpp1G/podpic.png" alt="The Growth Podcast" className="w-full h-48 object-cover" data-id="element-284" />
            <div className="p-6" data-id="element-285">
              <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-286">
                The Growth Podcast
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-287">
                Build Smarter. Scale Faster. Think Bigger. New episodes every
                Monday & Friday featuring top product leaders.
              </p>
              <motion.a href="https://www.news.aakashg.com/s/product-growth-podcast" className="px-6 py-3 bg-[#0FB9B1] text-white rounded-md font-medium hover:bg-[#0ca69e] transition-colors inline-block" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} target="_blank" rel="noopener noreferrer" data-id="element-288">
                Listen Now
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Call to Action Section */}
      <section className="bg-gray-50 py-20" data-id="element-289">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-290">
          <motion.div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-291">
            <div className="text-center mb-10" data-id="element-292">
              <motion.h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} data-id="element-293">
                The World's Foremost Expert on PLG Across B2B and B2C
              </motion.h2>
              <motion.p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.4
            }} data-id="element-294">
                With 16+ years of experience in both top-tier B2B and B2C
                product leadership positions, I can take your company to the
                next level.
              </motion.p>
              <motion.div className="flex flex-col md:flex-row justify-center gap-4" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.6
            }} data-id="element-295">
                <motion.a href="/resume" className="px-8 py-4 bg-[#0FB9B1] text-white rounded-md font-medium text-lg hover:bg-[#0ca69e] transition-colors flex items-center justify-center" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.97
              }} data-id="element-296">
                  Download Resume
                </motion.a>
                <motion.a href="mailto:productgrowthppp@gmail.com" className="px-8 py-4 bg-white text-[#0FB9B1] border-2 border-[#0FB9B1] rounded-md font-medium text-lg hover:bg-gray-50 transition-colors flex items-center justify-center" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.97
              }} data-id="element-297">
                  Email Me
                </motion.a>
              </motion.div>
            </div>
            <motion.div className="border-t border-gray-200 pt-8 mt-8 text-center" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.8
          }} data-id="element-298">
              <p className="text-gray-600 italic" data-id="element-299">
                "If you're looking for someone who can drive both vision and
                execution, who understands both product and growth, who can
                speak to engineers and executives with equal fluency — Aakash is
                your person."
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>;
};
export default Home;